import { css } from 'styled-components';

import { T_COLORS_FLAT } from '@styles/colors/themes/beam/beam-flat';

interface IType {
  fontWeight: number;
  fontSize: number;
  lineHeight: number;
  color: T_COLORS_FLAT[keyof T_COLORS_FLAT];
}

export const typeCSS = (type: IType, color = false) => css`
  font-size: ${type.fontSize}px;
  font-weight: ${type.fontWeight};
  line-height: ${type.lineHeight};
  ${color
    ? css`
        color: ${type.color};
      `
    : ''}
`;
